module.exports = __webpack_public_path__ + "media/images/crafts/crafts_m-5902085c90be77afb5614a71b486a38a.jpg";